import { Component, OnInit, Input, Renderer2 } from '@angular/core';
import { ThemeService } from '../../services/theme.service';
import { LayoutService } from '../../services/layout.service';
import { TranslateService } from '@ngx-translate/core';
import { JwtAuthService } from '../../services/auth/jwt-auth.service';
import { Utils } from '../../../utils/utils';

@Component({
  selector: 'app-header-side',
  templateUrl: './header-side.template.html',
  styleUrls: ['./header-side.component.scss']
})
export class HeaderSideComponent implements OnInit {
  @Input() notificPanel;
  public availableLangs = [
    { name: 'BR', code: 'br', flag: 'flag-icon-br' },
    { name: 'PT', code: 'pt', flag: 'flag-icon-pt' },
    { name: 'EN', code: 'en', flag: 'flag-icon-us' },
    { name: 'ES', code: 'es', flag: 'flag-icon-es' }
  ];
  currentLang = this.availableLangs[0];
  utils = Utils;
  public egretThemes;
  public layoutConf: any;

  constructor(
    private themeService: ThemeService,
    private layout: LayoutService,
    public translate: TranslateService,
    private renderer: Renderer2,
    public jwtAuth: JwtAuthService
  ) {}

  ngOnInit() {
    this.egretThemes = this.themeService.egretThemes;
    this.layoutConf = this.layout.layoutConf;
    this.translate.use(this.currentLang.code);
  }

  setLang(lng) {
    this.currentLang = lng;
    this.translate.use(lng.code);
  }

  toggleNotificationPanel() {
    if (this.notificPanel) {
      this.notificPanel.toggle();
    }
  }

  toggleSidenav() {
    if (this.layoutConf.sidebarStyle === 'closed') {
      return this.layout.publishLayoutChange({ sidebarStyle: 'full' });
    }
    this.layout.publishLayoutChange({ sidebarStyle: 'closed' });
  }

  callNfego() {
    window.open('https://infokaw.com.br/nfego', '_blank');
  }

  callV360() {
    window.open('https://infokaw.com.br/v360', '_blank');
  }

  callKawflex() {
    window.open('https://infokaw.com.br/kawflex', '_blank');
  }
}